/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import React, { useState, useEffect } from 'react';
import { UsersListComp, Header } from '../components';
import { TweetyModal } from '@vlinder-web/tweety-modal-widget-react';
import { useTheme } from '../../../providers/theme';
import { useSMUsersListPageGetContent, useSMNotifyUserUser } from '../machines';
import { Paginate } from '@vlinder-web/paginate-widget-react';
import { StateOSD } from '@vlinder-web/state-osd-v2-widget-react';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { vappContainer, VApplication } from '../../../application';
import { SettingsComp } from '../components/Settings';
import toast from 'react-hot-toast';
import { SearchFilter } from '../../../widgets/filter-widget-react';
import { MarriageCertificateListPageService } from '../services';
import { Modal } from 'react-bootstrap';
import { StorageModule } from '@vlinder-web/storage-module-react';
import { Loader } from '@/components';

const getSrv = () => {
  return vappContainer.get<MarriageCertificateListPageService>(
    MarriageCertificateListPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const theme = useTheme();
  const [refreshPagination, setReFreshPagination] = useState(new Date());
  const staticPageContentConfig = getSrv()?.agent?.getStaticPageContentSync({});
  const storageService = StorageModule.getInstance();

  const setApplicationsForPayment = (data: any[]) => {
    storageService.set('payableApplications', data, 'session');
    props?.onPaymentClick && props?.onPaymentClick();
  };

  const srv = getSrv();

  const { usersListPageSend, usersListPageState, usersListPageMachine } =
    useSMUsersListPageGetContent({});

  const { notifyUserUserSend, notifyUserUserState } = useSMNotifyUserUser({});

  const _onHeaderDDActionItemClick = (id: string) => {};

  const onError = () => {
    //window.location.reload(false);
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onRefresh = () => {
    usersListPageSend('TRIGGER_REFRESH', {});
    setReFreshPagination(new Date());
  };

  const onClearFilter = () => {
    Array.from(document.querySelectorAll('input')).forEach(
      (input) => (input.value = '')
    );
    usersListPageSend('TRIGGER_REFRESH', {});
  };

  const onApplyFilter = (data: any) => {
    let criteria: any = [];
    criteria = [
      {
        column: 'credentialNo',
        op: 'Equal',
        value: data?.credentialNo,
      },
    ];

    usersListPageSend('TRIGGER_REFRESH', {
      where: criteria,
    });
  };

  const onTogglePress = (key: string, id: string) => {
    console.log(`on toggle press ::`, key, id);
    if (key === 'notify') {
      notifyUserUserSend('START', {
        payload: {
          applicationID: id,
        },
      });
    }
    if (key === 'renew') {
      props?.onViewClick && props?.onViewClick(id);
    }
  };

  const _renderPage = () => {
    console.log(
      'usersListPageState?.event?.data?.value1',
      usersListPageState?.matches('GET_PAGE_CONTENT'),
      !usersListPageState?.event?.data?.value?.isEmpty
    );

    if (
      usersListPageState?.matches('GET_PAGE_CONTENT') ||
      !usersListPageState?.event?.data?.value?.isEmpty
    ) {
      return (
        <UsersListComp
          {...(usersListPageState?.event?.data?.value || {})}
          // {...staticPageContentConfig?.sampleData}
          // onTogglePress={onTogglePress}
          // proceedToPay={setApplicationsForPayment}
          onListClick={props?.onViewClick}
          isLoading={usersListPageState?.matches('GET_PAGE_CONTENT')}
          // onViewClick={props?.onViewClick}
          onRowClick={props?.onViewDetailClick}
        />
      );
    }

    if (usersListPageState?.event?.data?.value?.isEmpty) {
      return (
        <StateOSD {...(staticPageContentConfig?.loading?.usersEmpty || {})} />
      );
    }
    return <></>;
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <Header
            {...(staticPageContentConfig?.header || {})}
            onHeaderDDActionItemClick={_onHeaderDDActionItemClick}
            onRefreshClick={onRefresh}
          />
          {/* <SearchFilter
            {...(staticPageContentConfig?.settings || {})}
            onFilterApply={onApplyFilter}
            onClearFilter={onClearFilter}
          /> */}
          <SettingsComp
            {...(staticPageContentConfig?.settings || {})}
            onApplyFilter={onApplyFilter}
            onClearFilter={onClearFilter}
          />
        </>
      );
    }
    return null;
  };

  const onPaginationChange = (event: any) => {
    usersListPageSend('TRIGGER_REFRESH', {
      offset: event?.selected * 10,
      size: 10,
    });
  };

  const _renderPagination = () => {
    if (!usersListPageState?.event?.data?.value?.isEmpty) {
      return (
        <Paginate
          {...(usersListPageState?.event?.data?.value || {})}
          onPageChange={onPaginationChange}
          key={refreshPagination}
          totalItems={usersListPageState?.event?.data?.value?.ultUsers?.length}
        />
      );
    }
  };

  const _renderErrorModals = () => {
    if (usersListPageState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getUsers || {})}
          onAcknowledgement={onRefresh}
          onDeny={onRefresh}
        />
      );
    }
  };
  console.log('1st came');
  return (
    <div>
      {_renderHeader()}
      {_renderPage()}
      {_renderPagination()}
      {_renderErrorModals()}
    </div>
  );
};
